import type { Directive } from "vue";

/**
 * Arrastar com o mouse para rolar na horizontal ("drag to scroll"), como o dedo no celular.
 * Só para mouse (no toque o navegador já rola). Se arrastou, o clique que vem em seguida é
 * ignorado, para não abrir o card em que o arraste terminou.
 */
const DRAG_THRESHOLD = 5;

type DragState = { startX: number; startScroll: number; dragging: boolean; moved: boolean; cleanup: () => void };
const states = new WeakMap<HTMLElement, DragState>();

export const dragScroll: Directive<HTMLElement> = {
  mounted(el) {
    const state: DragState = { startX: 0, startScroll: 0, dragging: false, moved: false, cleanup: () => {} };

    const onDown = (e: PointerEvent) => {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      state.dragging = true;
      state.moved = false;
      state.startX = e.clientX;
      state.startScroll = el.scrollLeft;
    };
    const onMove = (e: PointerEvent) => {
      if (!state.dragging) return;
      const dx = e.clientX - state.startX;
      if (!state.moved && Math.abs(dx) < DRAG_THRESHOLD) return;
      if (!state.moved) {
        state.moved = true;
        el.classList.add("is-dragging");
      }
      el.scrollLeft = state.startScroll - dx;
      e.preventDefault();
    };
    const onUp = () => {
      if (!state.dragging) return;
      state.dragging = false;
      el.classList.remove("is-dragging");
    };
    const onClick = (e: MouseEvent) => {
      if (!state.moved) return;
      state.moved = false;
      e.preventDefault();
      e.stopPropagation();
    };
    // imagens e links arrastáveis do navegador atrapalham o arraste
    const onDragStart = (e: DragEvent) => e.preventDefault();

    el.addEventListener("pointerdown", onDown);
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
    el.addEventListener("click", onClick, true);
    el.addEventListener("dragstart", onDragStart);
    el.classList.add("drag-scroll");
    state.cleanup = () => {
      el.removeEventListener("pointerdown", onDown);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      el.removeEventListener("click", onClick, true);
      el.removeEventListener("dragstart", onDragStart);
    };
    states.set(el, state);
  },
  unmounted(el) {
    states.get(el)?.cleanup();
    states.delete(el);
  },
};
